import { render, staticRenderFns } from "./MaintenancePage.vue?vue&type=template&id=1117d978&scoped=true"
import script from "./MaintenancePage.vue?vue&type=script&setup=true&lang=js"
export * from "./MaintenancePage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MaintenancePage.vue?vue&type=style&index=0&id=1117d978&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1117d978",
  null
  
)

export default component.exports